const Franchisees = () => {
  return (<h1>Franchisees</h1>);
};

export default Franchisees;
